/**
 * Utility functions for managing store registration data in localStorage
 */

const STORE_REGISTRATION_STORAGE_KEY = 'salovare_storeRegistration_temp';

/**
 * Clear store registration data from localStorage
 * This should be called when user navigates away from store registration
 * or when registration is completed
 */
export const clearStoreRegistrationData = (storageKey = STORE_REGISTRATION_STORAGE_KEY) => {
  try {
    localStorage.removeItem(storageKey);
  } catch (error) {
    console.warn('Failed to clear store registration data from localStorage:', error);
  }
};

/**
 * Check if there's any store registration data in localStorage
 * @returns {boolean} True if data exists, false otherwise
 */
export const hasStoreRegistrationData = () => {
  try {
    const data = localStorage.getItem(STORE_REGISTRATION_STORAGE_KEY);
    return data !== null;
  } catch (error) {
    console.warn('Failed to check store registration data in localStorage:', error);
    return false;
  }
};

/**
 * Get store registration data from localStorage
 * @returns {Object|null} The stored data or null if not found
 */
export const getStoreRegistrationData = () => {
  try {
    const saved = localStorage.getItem(STORE_REGISTRATION_STORAGE_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch (error) {
    console.warn('Failed to load store registration data from localStorage:', error);
    return null;
  }
};
